const initState = {
  walletTransaction: [],
  otherTransaction: [],
  totalWalletAmount: {},
  walletMoreData: true,
  walletLastDocument: "",
  otherMoreData: true,
  otherLastDocument: "",
  ticketResponse: {},
  cashbackData: [],
  contractDetails: {},
};
const walletReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET-WALLET-TRANSACTION":
      return {
        ...state,
        walletTransaction: [
          ...state.walletTransaction,
          ...action.payload.temp_data,
        ],
        walletMoreData: action.payload.hasMoreDocument,
        walletLastDocument: action.payload.lastDocument,
      };
    case "GET-OTHER-TRANSACTION":
      return {
        ...state,
        otherTransaction: [
          ...state.otherTransaction,
          ...action.payload.temp_data,
        ],
        otherMoreData: action.payload.hasMoreDocument,
        otherLastDocument: action.payload.lastDocument,
      };
    case "GET-WALLET-TRANSACTION-EMPTY":
      return {
        ...state,
        walletTransaction: action.payload.temp_data,
        moreData: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    case "GET-OTHER-TRANSACTION-EMPTY":
      return {
        ...state,
        otherTransaction: action.payload.temp_data,
        otherMoreData: action.payload.hasMoreDocument,
        otherLastDocument: action.payload.lastDocument,
      };
    case "GET-TOTAL-AMOUNT":
      return {
        ...state,
        totalWalletAmount: action.payload,
      };
    case "CONTRACT_DETAILS":
      return {
        ...state,
        contractDetails: action.payload,
      };
    case "TICKET_RESPONSE":
      return {
        ...state,
        ticketResponse: action.payload,
      };
    case "GET_CASHBACK_DATA":
      return {
        ...state,
        cashbackData: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default walletReducer;
